require('../../sass/components/_loader.scss');

export const Loader = {
    name: 'Loader',
    props: {
        size: String
    },
    computed: {
        rootClasses() {
            return ['loader', this.size === 'small' && 'loader--small'];
        }
    },
    template: `
        <span :class="rootClasses"></span>
    `
};